import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { RevealText, Reveal } from "@/components/site/Reveal";

const HERO_IMG = "https://images.pexels.com/photos/12641124/pexels-photo-12641124.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1600";

const SECTORS = [
  { name: "Consumer, Retail & Fashion", img: "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { name: "Manufacturing & Industrial", img: "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { name: "Healthcare & Pharma", img: "https://images.unsplash.com/photo-1579165466949-3180a3d056d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { name: "Chemicals & Hazardous Material", img: "https://images.unsplash.com/photo-1546185058-592ead754d27?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { name: "Aerospace & Defense", img: "https://images.unsplash.com/photo-1772161166556-67d412d8ac76?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { name: "Automotive & Mobility", img: "https://images.unsplash.com/photo-1567789884554-0b844b597180?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { name: "Oil, Gas & Energy", img: "https://images.pexels.com/photos/10386893/pexels-photo-10386893.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200" },
  { name: "Trade Shows & Exhibitions", img: "https://images.unsplash.com/photo-1743119844808-fefd446de533?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <section className="relative pt-40 pb-20 mx-auto max-w-[1600px] px-5 sm:px-8">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-primary mb-6">/ Industries</p>
        <h1 className="font-display uppercase tracking-tighter leading-[0.85] text-[13vw] sm:text-[10vw] lg:text-[8vw]">
          <RevealText lines={["Industries", "we serve"]} testid="page-title" />
        </h1>
        <Reveal delay={0.4}>
          <p className="mt-8 max-w-3xl text-white/70 text-xl leading-relaxed">
            Freight IQ supports a wide range of industries with customized, efficient logistics solutions. From global retailers to manufacturers, our clients benefit from a streamlined, competitive supply chain backed by deep industry expertise and a clear understanding of their needs. Our experienced teams deliver tailored strategies that drive real results—worldwide.
          </p>
        </Reveal>
      </section>

      <section className="relative h-[60vh] overflow-hidden">
        <img src={HERO_IMG} alt="Illuminated oil refinery at night" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
      </section>

      <section data-testid="key-sectors" className="mx-auto max-w-[1600px] px-5 sm:px-8 py-24">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">/ Key Sectors</p>
          <h2 className="font-display text-4xl sm:text-6xl uppercase tracking-tighter leading-[0.9]">Where we add value.</h2>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 auto-rows-[300px]">
          {SECTORS.map((s, i) => (
            <Reveal key={s.name} delay={(i % 4) * 0.06}>
              <div data-testid={`sector-${i}`} className="group relative h-full w-full overflow-hidden border border-white/10 hover:border-primary/60 transition-colors duration-500">
                <img src={s.img} alt={s.name} className="absolute inset-0 h-full w-full object-cover opacity-55 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700 ease-out" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                <div className="relative z-10 h-full p-6 flex flex-col justify-between">
                  <span className="font-mono text-xs text-primary">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-display text-2xl uppercase tracking-tight leading-tight">{s.name}</h3>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-white/10 bg-[#080808]">
        <div className="mx-auto max-w-[1600px] px-5 sm:px-8 py-24 flex flex-col sm:flex-row sm:items-center justify-between gap-8">
          <h2 className="font-display text-3xl sm:text-5xl uppercase tracking-tighter max-w-3xl">
            Contact your Freight IQ specialist for a conversation on how we can add value to your supply chain.
          </h2>
          <a href="mailto:sales@freight-iq.com?subject=New%20Enquiry%20-%20Freight%20IQ" data-testid="industries-cta" className="inline-flex items-center gap-3 hover-fill px-8 py-4 font-mono text-xs uppercase tracking-widest w-fit shrink-0">
            Connect with us <ArrowUpRight size={16} />
          </a>
        </div>
      </section>
    </div>
  );
}
